import type { ContestantImportExtended } from '@/components/Participant/ContestantImportExtended';
import { SettingsBase } from './SettingsBase';

/**
 * Contains the saved settings for the contestant imports for a user
 */
export class ContestantImportSettings extends SettingsBase {
    static NAME_OF_CLASS = 'ContestantImportSettings';
    public Formats?: ContestantImportExtended[];

    constructor(val?: ContestantImportSettings) {
        super();
        this.Formats = val?.Formats ?? [];
    }

    /**
     * Add a format to the settings
     * @param format The format to add
     */
    public AddFormat(format: ContestantImportExtended) {
        if (!this.Formats) {
            this.Formats = [];
        }

        this.Formats.push(format);
    }

    /**
     * Remove a format from the settings
     * @param formatname The name of the format to remove
     */
    public RemoveFormat(formatname: string) {
        if (!this.Formats) {
            return;
        }

        this.Formats = this.Formats.filter((f) => f.Name?.toLocaleLowerCase() !== formatname.toLocaleLowerCase());
    }
}
